import {
    HIDE_MESSAGE,
    INIT_URL,
    ON_HIDE_LOADER,
    ON_SHOW_LOADER,
    SHOW_MESSAGE,
    SIGNIN_USER_SUCCESS,
    SIGNOUT_USER_SUCCESS,
    SIGNUP_USER_SUCCESS,
    SIGNOUT_USER,
    SERVER_RESTORE_PASSWORD,
    RESTORE_PASSWORD_SUCCESS,
    RESTORE_PASSWORD_ERROR,
    RESET_RESTORE_PASSWORD_SUCCESS_FLAG,
    SERVER_LOGIN,
    SERVER_LOGIN_WITH_TOKEN,
    CONNECTION_ERROR,
    CONNECTION_SUCCESS,
    SERVER_GENERATE_RECOVERY_KEY,
    GENERATE_RECOVERY_KEY_FEEDBACK,
    SERVER_SET_RECOVERY_PASSWORD,
    SET_RECOVERY_PASSWORD_FEEDBACK
} from 'constants/ActionTypes';

const INIT_STATE = {
    loader: false,
    alertMessage: '',
    showMessage: false,
    initURL: '',
    authUser: localStorage.getItem('authToken'),
    loggedIn: false,
    tokenExpireTime: localStorage.getItem('tokenExpireTime'),
    recoverPasswordLoading: false,
    restorePasswordSuccess: false,
    generateRecoveryKeyLoading: false,
    generateRecoveryKeyError: false,
    setRecoveryPasswordLoading: false,
    setRecoveryPasswordError: false,
    connectionError: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SERVER_LOGIN:
            return {
                ...state,
                initURL: '/'
            };
        case SERVER_LOGIN_WITH_TOKEN:
            return {
                ...state,
                authUser: null
            };
        case SIGNUP_USER_SUCCESS: {
            return {
                ...state,
                loader: false,
                authUser: action.payload
            };
        }
        case SIGNIN_USER_SUCCESS: {
            return {
                ...state,
                loader: false,
                loggedIn: true,
                tokenExpireTime: action.payload.tokenExpireTime ? action.payload.tokenExpireTime : state.tokenExpireTime,
                authUser: action.payload.token
            };
        }
        case SERVER_RESTORE_PASSWORD:
            return { ...state, restorePasswordLoading: true };
        case RESTORE_PASSWORD_SUCCESS:
            return { ...state, restorePasswordLoading: false, restorePasswordSuccess: true };
        case RESTORE_PASSWORD_ERROR:
            return { ...state, restorePasswordLoading: false, restorePasswordSuccess: false };
        case RESET_RESTORE_PASSWORD_SUCCESS_FLAG:
            return { ...state, restorePasswordLoading: false, restorePasswordSuccess: false };
        case INIT_URL: {
            return {
                ...state,
                initURL: action.payload
            };
        }
        case SIGNOUT_USER_SUCCESS:
            return {
                ...state,
                authUser: null,
                tokenExpireTime: null,
                initURL: '/',
                loader: false,
                connectionError: false
            };
        case SIGNOUT_USER:
            return {
                ...state,
                authUser: null,
                tokenExpireTime: null,
                initURL: '/',
                loggedIn: false,
                loader: false
            };
        case SHOW_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case HIDE_MESSAGE: {
            return {
                ...state,
                alertMessage: '',
                showMessage: false,
                loader: false
            };
        }
        case ON_SHOW_LOADER: {
            return {
                ...state,
                loader: true
            };
        }
        case ON_HIDE_LOADER: {
            return {
                ...state,
                loader: false
            };
        }
        case CONNECTION_ERROR: {
            return { ...state, connectionError: true };
        }
        case CONNECTION_SUCCESS: {
            return { ...state, connectionError: false };
        }
        case SERVER_GENERATE_RECOVERY_KEY:
            return { ...state, generateRecoveryKeyLoading: true, generateRecoveryKeyError: false };
        case GENERATE_RECOVERY_KEY_FEEDBACK:
            return { ...state, generateRecoveryKeyLoading: false, generateRecoveryKeyError: !action.payload.success };
        case SERVER_SET_RECOVERY_PASSWORD:
            return { ...state, setRecoveryPasswordLoading: true, setRecoveryPasswordError: false };
        case SET_RECOVERY_PASSWORD_FEEDBACK:
            return { ...state, setRecoveryPasswordLoading: false, setRecoveryPasswordError: !action.payload.success };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/Auth.js